<tui-input-number
  formControlName="sortOrder"
  [tuiTextfieldSize]="tuiElementLargeSize"
  [class.tui-skeleton]="loading"
  [class.tui-skeleton_text]="loading"
>
  <!-- Изменить -->
  {{ 'components.contacts.fields.contactSortOrder' | translate }}
</tui-input-number>
